import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { getConnectorV1Name, getConnectorV2Name } from 'shell-models-lib';

export const serviceNowObjectMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.serviceNow.datasetType,
    disabled: __IS_FABRIC_DPE__,
    displayName: getConnectorV1Name(stringResources.ServiceNow_DisplayText),
    supportLinkedServiceTypes: [adfModelTypeMap.serviceNow.linkedServiceType],
    warningMessage: format(
        stringResources.Connector_Legacy_IsNotSupportedWarning_alt2,
        stringResources.DatasetLowerCase,
        getConnectorV2Name(stringResources.ServiceNow_DisplayText)
    ), 
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-servicenow?tabs=data-factory',
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-servicenow'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
